<template>
    <div v-if="!wordPressSSR" class="cookie-authority ca" :class="{ active: show }">
        <div class="cookie-banner">
            <div class="head-title">{{ $t('common:cookie.caTitle') }}</div>
            <div class="content">
                <p>{{ $t('common:cookie.caDesc1') }}</p>
                <p 
                    v-click="{
                        selector: '.manage-preferences',
                        callback: onPreferences
                    }"
                    v-html="$t('common:cookie.caDesc3')"
                ></p>
            </div>
            <div
                class="cookie-btn accept"
                role="button"
                tabindex="2"
                @click="setCookieAll(true)"
            >
                {{ $t('common:cookie.acceptAllCookie') }}
            </div>
        </div>
    </div>
</template>

<script>
import mixin from './mixin';

export default {
    mixins: [mixin]
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
.cookie-authority.ca {
    position: fixed;
    bottom: 0;
    left: 0;
    transform: translateY(100%);
    transition: transform 0.5s ease;
    height: 100vh;
    width: 100vw;
    z-index: calc(var(--level-high) - 2);
    background: rgba(0,0,0,0);
    &.active {
        transform: translateY(0);
        background: rgba(0,0,0,0.2);
    }
    .cookie-banner {
        position: absolute;
        bottom: 0;
        left: 0;
        background: var(--g-bg-color);
        width: 100%;
        color: var(--g-text-color);
        z-index: var(--level-subhigh);
        box-shadow: 0px -10px 20px rgba(25, 25, 25, 0.2);
        padding: 20px 50px;
        @include media-800 {
            padding: 15px;
            width: 100%;
        }
        
        .head-title {
            color: var(--g-primary-color);
            font-family: var(--font-bold);
            padding: var(--var-padding);
            font-size: 20px;
        }
        .content {
            font-size: 14px;
            padding: 15px 0;
            color: var(--color-label);
            line-height: 1.75;
            a,
            span {
                text-decoration: underline;
                cursor: pointer;
                white-space: nowrap;
                color: #4c84ff;
                font-size: var(--font-text-size);
            }
        }

        .cookie-btn {
            cursor: pointer;
            padding: 0 25px;
            font-family: var(--font-medium);
            height: 40px;
            line-height: 40px;
            white-space: nowrap;
            text-align: center;
            color: var(--g-btn-color);
            background: var(--g-btn-background);
            display: inline-block;
            @include media-800 {
                padding: 0;
                display: block;
            }
        }
    }
}
</style>
